import type { BranchTagTranslationEntity } from './BranchTagTranslationEntity'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'

export class BranchTagsEntity {
  id?: number
  imageUrl?: string | null
  channel?: ChannelMiniEntity
  channelName?: string | null
  branches?: BranchMiniEntity[]
  translations?: Array<BranchTagTranslationEntity> | null
  isActive?: boolean
  order?: number | null
}
